import { displayDigits } from '../utils/displayDigits';
import React from 'react';
import { formatNotificationBadgeCount } from '../utils/countUnreadNotifications';

interface NotificationBadgeProps {
  count: number;
  className?: string;
}

export function NotificationBadge({ count, className }: NotificationBadgeProps) {
  if (count <= 0) return null;
  return (
    <span className={className ?? 'notification-badge'} aria-hidden>
      {displayDigits(formatNotificationBadgeCount(count))}
    </span>
  );
}
